<template>
    <div>
        <div>
            <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
            <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
        </div>
        <b-card class="mainCardBG">
            <b-card-text>
                <b-navbar class="formCard"
                    style="border-radius: 5px !important; padding-left: 0px;height:auto !important;" toggleable="lg"
                    type="dark" variant="primary">
                    <b-navbar-nav>
                        <b-button @click="previousSalesView" size="sm" variant="light">
                            <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
                        </b-button>
                    </b-navbar-nav>
                    <b-navbar-brand center>Charges Details</b-navbar-brand>

                    <!-- <b-button
                size="sm"
                class="ml-1"
                @click="getReportsReverse('CHARGES_LIST_EXCEL')"
                variant="outline-info"
                >Export as Excel</b-button
                > -->
                    <b-button :disabled="ExcelBtnName != 'Export as Excel' ? true : false" class="ml-3"
                        @click="getReportsReverse('CHARGES_LIST_EXCEL', 'Export as Excel')" size="sm"
                        variant="outline-info">{{ ExcelBtnName }}
                        <b-spinner v-if="ExcelBtnName != 'Export as Excel'" small
                            label="Small Spinner"></b-spinner></b-button>
                </b-navbar>

                <b-card class="formCard">
                    <b-card-text>
                        <!-- Add Update Form Input End-->
                        <b-card class="gutr" v-if="addEditCard">
                            <b-row class="align-items-end">
                                <b-col md="12">
                                    <h5> Charges Details</h5>
                                </b-col>
                                <b-col md="3">
                                    <label>
                                        Charges Name
                                        <span class="error">*</span>
                                    </label>

                                    <b-form-input :formatter="capitalizeAll" id="chargesName" name="chargesName"
                                        v-model="ChargesMaster.chargesName" placeholder="Charge Name"></b-form-input>
                                    <span class="error" v-if="!ChargesMaster.chargesName">
                                        {{
                                        errorList.chargesName
                                        }}
                                    </span>
                                </b-col>
                                <b-col md="3">
                                    <label>
                                        Charges Code
                                        <span class="error">*</span>
                                    </label>
                                    <b-form-input :formatter="capitalizeAll" id="chargesCode" name="chargesCode"
                                        v-model="ChargesMaster.chargesCode" placeholder="Charge Code"></b-form-input>
                                    <span class="error" v-if="!ChargesMaster.chargesCode">
                                        {{
                                        errorList.chargesCode
                                        }}
                                    </span>
                                </b-col>
                                <b-col md="3">
                                    <label>Status :</label>
                                    <md-switch :id="'approval'+chargesMaster.isChargesActive" name="approval"
                                        class="md-primary" :value="ChargesMaster.isChargesActive==1?true:false"
                                        @change="activatechargesMaster()">
                                        <h6>
                                            <b-badge
                                                :variant="ChargesMaster.isChargesActive==1?'success':'danger'">{{ChargesMaster.isChargesActive==1?"Active":"In-Active"
                                                }}</b-badge>
                                        </h6>
                                    </md-switch>
                                </b-col>

                                <b-col md="6">
                                    <label>
                                        Charges Description
                                        <span class="error">*</span>
                                    </label>
                                    <b-form-textarea :formatter="capitalizeAll" id="chargesDescription"
                                        name="chargesDescription"
                                        v-model="ChargesMaster.chargesDescription"></b-form-textarea>
                                    <span class="error" v-if="!ChargesMaster.chargesDescription">
                                        {{
                                        errorList.chargesDescription
                                        }}
                                    </span>
                                </b-col>
                                <b-col md="12">
                                    <center>
                                        <b-button style="margin-bottom: 0.3rem" variant="success"
                                            @click="addchargesMaster" class="mt-2" id="addButtonLoader">
                                            {{
                                            ChargesMaster.idmasterChargers ? "Update" : "Save"
                                            }}
                                        </b-button>
                                    </center>
                                    <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                                </b-col>
                            </b-row>
                        </b-card>
                        <!-- Add Update Form Input End-->

                        <!-- Search Form Input Start-->
                        <div class="mt-3">
                            <b-row>
                                <b-col md="10" class="my-1">
                                    <b-form-group>
                                        <b-input-group>
                                            <b-form-input :formatter="capitalizeAll" @input="debounceSearch"
                                                v-model="filter" placeholder="Type to Search Charges Master and Code"
                                                ref="search" />
                                            <b-input-group-append>
                                                <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col md="2">
                                    <b-button variant="outline-primary" @click="addEditCardFunc()"
                                        size="sm">Add</b-button>
                                    <h5 class="text-muted pull-right mt-2 ml-3">
                                        <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                                    </h5>
                                </b-col>
                            </b-row>
                        </div>
                        <!-- Search Form Input End-->

                        <div class="mt-3">
                            <!-- Main table element -->
                            <div class="table-responsive tableMain">
                                <b-table show-empty stacked="md" :items="All_Charges_List_data" responsive
                                    :fields="Columns" primary-key="common_over_id" :per-page="perPage"
                                    :current-page="currentPage" :filter="filter" :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                                    class="position-relative">
                                    <template slot="idmasterChargers" slot-scope="row0">
                                        <span>
                                            {{
                                            row0.index + 1 + (currentPage - 1) * perPage
                                            }}
                                        </span>
                                    </template>
                                    <template slot="chargesName" slot-scope="row1">
                                        <span>{{(row1.item.chargesName!='')?row1.item.chargesName:'--'}}</span>
                                    </template>
                                    <template slot="chargesCode" slot-scope="row11">
                                        <span>{{(row11.item.chargesCode!='')?row11.item.chargesCode:'--'}}</span>
                                    </template>
                                    <template slot="chargesDescription" slot-scope="row12">
                                        <span>{{(row12.item.chargesDescription!='')?row12.item.chargesDescription:'--'}}</span>
                                    </template>
                                    <template slot="isChargesActive" slot-scope="row22">
                                        <div v-if="adminToggle =='Admin'" :id="'row'+row22.item.idmasterChargers">
                                            <md-switch :id="'approval'+row22.item.idmasterChargers" name="approval"
                                                class="md-primary" :value="row22.item.isChargesActive==1?true:false"
                                                @change="activateChargesUser(row22.item)">
                                                <h6>
                                                    <br>
                                                    <b-badge
                                                        style="margin-left:-45px">{{row22.item.isChargesActive==1?'Active':'In-Active'}}</b-badge>
                                                </h6>
                                            </md-switch>
                                        </div>
                                        <div v-else :id="'row'+row22.item.idmasterChargers">
                                            <h6>
                                                <b-badge>{{row22.item.isChargesActive==1?'Active':'In-Active'}}</b-badge>
                                            </h6>
                                        </div>
                                    </template>
                                    <template slot="action" slot-scope="row2">
                                        <b-button variant="outline-primary" @click="editchargesMaster(row2.item)"
                                            id="addButtonLoader" size="sm">Update</b-button>
                                    </template>
                                    <template slot="companyName" slot-scope="row14">
                                        <span>
                                            Company Name : {{row14.item.companyName}}
                                            <br>
                                        </span>
                                        <span>
                                            Address : {{row14.item.address}}
                                            <br>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                            <b-row>
                                <b-col md="12" class="my-1">
                                    <b-pagination limit="5" :total-rows="totalRows" :per-page="perPage"
                                        v-model="currentPage" class="my-0 pull-right" />
                                </b-col>
                            </b-row>
                        </div>
                    </b-card-text>
                </b-card>
            </b-card-text>
        </b-card>
        <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    </div>
</template>
  
<script>
    import DatePicker from "vue2-datepicker";
    import axios from "axios";
    import moment from "moment";
    import { ModelListSelect, MultiSelect } from "vue-search-select";
    // import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";
    import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
    import { DateFormat, selectDateFormat } from "../../helper/filters";
    import { globalPermissionStatus } from "../../helper/collection";
    import CommonService from "../../services/CommonService.js";
import ClientUserService from "../../services/ClientUserService.js";
import CustomLoader from "../common/customLoader.vue";
    export default {
        beforeMount() {
            if (
                this.$sessionsStorage.get("loginId") != undefined &&
                this.$sessionsStorage.get("loginId") != ""
            ) {
                this.$store.dispatch("setCurrentRoute", "/ChargesMaster");
                if (globalPermissionStatus("Charges Master") != "Disabled") {
                this.$sessionsStorage.set(
                    "PermissionStatus",
                    globalPermissionStatus("Charges Master")
                );
                } else {
                this.$router.push({
                    path: "/dashboard"
                });
                }
                this.getAllChargesMasterList();
            } else {
                this.$router.push({
                path: "/Login/"
                });
            }

        },
        data() {
            return {
                ExcelBtnName: "Export as Excel",
                addEditCard: false,
                isLoading: false,
                Columns: [
                    {
                        key: "idmasterChargers",
                        label: "SN",
                        sortable: true,
                        sortDirection: "desc"
                    },
                    {
                        key: "chargesName",
                        label: "Charges Name",
                        sortable: true,
                        sortDirection: "desc"
                    },
                    {
                        key: "chargesCode",
                        label: "Charges Code",
                        sortable: true,
                        sortDirection: "desc"
                    },
                    {
                        key: "chargesDescription",
                        label: "Charges Description",
                        sortable: true,
                        sortDirection: "desc"
                    },
                    {
                        key: "isChargesActive",
                        label: "Status",
                        sortable: true,
                        sortDirection: "desc"
                    },
                    {
                        key: "action",
                        label: "Actions",
                        sortable: true,
                        sortDirection: "desc"
                    }
                ],
                currentPage: 1,
                perPage: 10,
                totalRows: "",
                sortBy: null,
                sortDesc: false,
                pageOptions: [5, 10, 15],
                adminToggle: this.$sessionsStorage.get("designation"),
                sortDirection: "desc",
                filter: null,
                changePageFilter: "0",
                modalInfo: { title: "", content: "" },
                alert: {
                    content: "Added Succesfully",
                    ok: "ok"
                },
                ChargesMaster: {
                    idmasterChargers: "",
                    chargesName: "",
                    chargesCode: "",
                    chargesDescription: "",
                    isChargesActive: true,
                    TypeofAdd: "Charges Master Add"
                },
                ChargesMasterError: [
                    "Please Enter Charges Name",
                    "Please Select Charges Code",
                    "Please Enter Charges Description"
                ],
                errorList: {
                    chargesName: "",
                    chargesCode: "",
                    chargesDescription: ""
                },
                All_Charges_List_data:[],
                validate: true,
                visible: false
            };
        },  
        filters: {
        },
        mounted() {},
    
        beforeDestroy() {},
    
        destroyed() {},
    
        components: {
            // Loading
            CustomLoader,
        },
    
        computed: {
            sortOptions() {
            // Create an options list from our fields
            return this.Columns.filter(f => f.sortable).map(f => {
                return { text: f.label, value: f.key };
            });
            }
        },
        methods: {   
            activatechargesMaster() {
                if (this.chargesMaster.isChargesActive == 1 || this.chargesMaster.isChargesActive == true) {
                    this.chargesMaster.isChargesActive = false;
                } else if ( this.chargesMaster.isChargesActive == 0 || this.chargesMaster.isChargesActive == false) {
                    this.chargesMaster.isChargesActive = true;
                }
            },
            
            clearErrVal() {
                this.chargesMaster = {
                    chargesName: "",
                    chargesCode: "",
                    chargesDescription: "",
                    isChargesActive: true,
                    TypeofAdd: "Charges Master Add"
                };
                this.errorList = {
                    chargesName: "",
                    chargesCode: "",
                    chargesDescription: ""
                };
            },
            activateChargesUser(item, index) {
                this.itemObj = item;
                this.indexNew = index;

                this.itemObj.isChargesActive = this.itemObj.isChargesActive == 1 ? 0 : 1;
                let paylod = {
                    tableName: "masterChargers",
                    tableId: "idmasterChargers",
                    tableIsActive: "isChargesActive",
                    value1: this.itemObj.isChargesActive,
                    tableVal: item.idmasterChargers,
                    isMailSend:'No',
                     manual:'No',
                };

                ClientUserService.getAllActive(JSON.stringify(paylod))
                .then((response) => {
                    const { data, status, statusText } = response;
                    if (status == 200 && data) {
                    }
                })
                .catch((error) => {
                    console.log("Catch on Proforma Error: ", error);
                });
            },
            previousSalesView() {
                window.history.go(-1);
            },
            filterClear() {
                this.chargesMaster = {
                    chargesName: "",
                    chargesCode: "",
                    chargesDescription: "",
                    isChargesActive: true,
                    TypeofAdd: "Charges Master Add"
                };
            },
            editchargesMaster(item) {
                this.clearErrVal();
                this.addEditCard = true;
                item.TypeofAdd = "Charges Master Add";
                this.ChargesMaster = item;
                this.setFocus();
            },
            addEditCardFunc() {
                this.clearErrVal();
                this.addEditCard = !this.addEditCard;
            },
            validateChargesMaster() {
                let validate_new = true;
                Object.keys(this.errorList).map((x, index) => {
                    if (
                    this.ChargesMaster[x] == "" ||
                    this.ChargesMaster[x] == undefined ||
                    this.ChargesMaster[x] == null
                    ) {
                        console.log("this.ChargesMaster[x]=>",this.ChargesMaster[x],x);
                        console.log("this.ChargesMaster[x]=>",this.ChargesMaster);
                    this.errorList[x] = this.ChargesMasterError[index];
                    validate_new = false;
                    }
                });
                if (validate_new != true) {
                    this.validate = false;
                    return;
                } else {
                    this.validate = true;
                }
            },
            addchargesMaster() {
                this.validateChargesMaster();
                this.ChargesMaster.TypeofAdd = "Charges Master Add";
                if (this.validate == false) return false;
                this.isLoading = true;

                let payload = {
                    itemCode: "add_Charges_Details",
                    ChargesMaster: this.ChargesMaster
                };
                payload = JSON.stringify(payload);
                if (this.validate != false) {
                    CommonService.getAllCommonMaster(payload)
                    .then(response => {
                        const { data, status, statusText } = response;
                        if (data.idmasterChargers != "" && data.idmasterChargers != undefined) {
                        if (data.find == 1 || data.find == 2) {
                            this.alert.content = data.MSG;
                        } else {
                            this.alert.content = data.MSG;
                        }
                        this.addEditCardFunc();
                        this.getAllChargesMasterList();
                        } else {
                        this.alert.content = data.MSG;
                        }
                        this.isLoading = false;
                        this.$refs["addPop"].open();
                    })
                    .catch(error => {
                        console.log("Catch on Proforma Error: ", error);
                    });
                }
            },
            getReportsReverse(id, btnName) {
                let excelIdGivin = "";
                if (id == "CHARGES_LIST_EXCEL") {
                    excelIdGivin = "CHARGES_LIST_EXCEL";
                }
                let payload = {
                    excelId: excelIdGivin,
                    Filter: this.Filter
                };
                this.ExcelBtnName = "Downloading Please Wait...";
                this.$store.dispatch(
                    "common/setAllPendingReverseTallyExcel",
                    JSON.stringify(payload)
                );
                let ExcelName = "";
                if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
                    this.ExcelBtnName = btnName;
                    ExcelName = this.$store.getters[
                    "common/getAllPendingReverseTallyExcel"
                    ];
                }
            },
            getAllChargesMasterList() {
                this.isLoading = true;
                let payload = {
                    itemCode: "All_Charges_List",
                    Filter: this.Filter
                };
                // JSON.stringify();
                // await
                CommonService.getAllCommonMaster(payload)
                .then(response => {
                    const { data, status, statusText } = response;
                    if (status == 200 && data) {
                        this.All_Charges_List_data = data.All_Charges_List_data;
                        this.totalRows = data.All_Charges_List_data.length;
                        console.log(" All_Charges_List response=>", data);
                    } else {
                        this.All_Charges_List_data = [];
                    }
                    this.isLoading = false;
                })
                .catch(error => {
                    console.log("Catch on All_Charges_List Error: ", error);
                });
            },
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
            JqueryFun() {
                return $(function() {
                    return $("#portLocationNew").DataTable();
                });
            },
            debounceSearch(event) {
                clearTimeout(this.debounce);
                this.debounce = setTimeout(() => {
                    this.getAllChargesMasterList();
                }, 1000);
            },
            setFocus: function() {
                // Note, you need to add a ref="search" attribute to your input.
                this.$refs.search.focus();
            },
        }
    };
</script>
  
<style>
  .md-direction-bottom-right {
    width: 30% !important;
  }
  .mrgtop-2per {
    margin-top: 1%;
  }
  .mrgtop-5px {
    margin-top: 0px;
  }
  .center {
    text-align: center;
  }
  .heght-1px {
    height: 1px;
  }
  
  .b-form-input-container {
    margin: 4px 0 12px !important;
  }
  .md-button-color {
    background-color: #607d8d !important;
  }
  
  .md-button-color-toggle {
    background-color: rgba(153, 153, 153, 0.4) !important;
  }
  
  .activeClass {
    display: none;
  }
  .error {
    color: red;
  }
</style>


// WEBPACK FOOTER //
// chargesMaster.vue?c16c6944